import { Component, OnInit } from '@angular/core';

import { StrikeDetails } from "src/app/shared/interfaces/strike-details";

import { NotificationService } from '../../core/notification.service';
import { StrikeService } from '../../core/strike.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit{

  loadingStrikes = true;
  currentStrikes: StrikeDetails = [];
  constructor(private strikes: StrikeService, private notificationService: NotificationService) { }

  ngOnInit() {
    this.loadStrikes().then(() => {
      this.loadingStrikes = false;
    });
  }

  async loadStrikes() {
    const strikes: StrikeDetails = await this.strikes.getCurrentStrikes();
    if (strikes.length) {
      this.currentStrikes = strikes;
    }
    else {
      this.notificationService.displayError('No strikes found');
    }
  }
}
